import { render, staticRenderFns } from "./AiAcrossDimensions.vue?vue&type=template&id=9a7d43b8&scoped=true&"
import script from "./AiAcrossDimensions.vue?vue&type=script&lang=js&"
export * from "./AiAcrossDimensions.vue?vue&type=script&lang=js&"
import style0 from "./AiAcrossDimensions.vue?vue&type=style&index=0&id=9a7d43b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7d43b8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VProgressCircular,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a7d43b8')) {
      api.createRecord('9a7d43b8', component.options)
    } else {
      api.reload('9a7d43b8', component.options)
    }
    module.hot.accept("./AiAcrossDimensions.vue?vue&type=template&id=9a7d43b8&scoped=true&", function () {
      api.rerender('9a7d43b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AiAcrossDimensions.vue"
export default component.exports